import React, { Fragment, useState,useEffect,useContext } from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate,useLocation } from "react-router";
import FBannerSpendResponsive from "../../components/FBannerSpendResponsive/FBannerSpend";
import FcardPaymentMethod from "../../components/FcardPaymentMethod/FcardPaymentMethod";
import FInput from "../../components/FInput/FInput";
import { QRCode } from "react-qrcode-logo";
import {useProcessor} from '../../hooks/useProcessor'
import { v4 as uuidv4 } from "uuid";
import { AuthContext } from "../../context/AuthContext";
import Swal from "sweetalert2";

const CodiPaymentScreen = ({ param }) => {


  const route = useNavigate();
  const { state } = useLocation();
  const { processPayment } = useProcessor();
  const [ref, setRef] = useState('0000')
  const {setAlert} = useContext(AuthContext)





  useEffect(() => {

      if(state == null){
        route('/')
      }else{
        const nextScreen = async () => {

          const data = {
              originCurrencyId: state.originCurrency,
              destinationCurrencyId: state.destinationCurrencyId,
              products: [
                  {
                      id: state.idFiadoFlash,
                      amount: state.transferredAmount
                  },
                  {
                      id: state.productId
                  }
              ]
          }

          let response = await processPayment(data, uuidv4());
          //console.log(response);
          if (response?.data?.code == "PROCESS_OK") {
              setRef(JSON.stringify(response.data.data.reference) + "")
          } else {
            Swal.fire({
              showCloseButton: true,
              title: 'Advertencia',
              text: 'Ha habido un error al procesar tu transacción, intenta de nuevo por favor',
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: '#fd6e0d',
              iconColor: "#fd6e0d",
              confirmButtonText: 'Entendido'
            })
          }
      }

      nextScreen();
      }

      
  }, []);


  return (
    <>
    {state != null ? 
      <>
      
      <div className="max-w-7xl mx-auto px-0 sm:px-6 md:px-8">
        <div className="py-4 border-0 border-dashed sm:p-3 max-h-screen mb-5">
          <div className="border-0 text-center grid grid-cols-1 justify-items-center">
            <div className="border-0 w-full rounded-2xl grid grid-cols-1 gap-5 sm:gap-5 px-10 py-5">
              <div className="border-0 col-span-1">
                <div className="w-full border-0 grid grid-cols-1 justify-items-center">
                  <QRCode
                    value={ref}
                    logoImage={require("../../components/assets/images/adaptive-icon.png")}
                  />
                </div>
              </div>
              <div className="border-0 col-span-1 sm:text-xl font-bold pt-10">
                Escanea o importa este código QR en tu aplicación para pagar tu
                Fiado
              </div>
              <div className="border-0 col-span-1 grid items-center justify-center">
                <div className="w-96">
                  <FInput type="botton" title="Finalizar" />
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
      </> : route('/')
    }
      
    </>
  );
};

export default CodiPaymentScreen;
